module.exports = __webpack_public_path__ + "static/media/Assessment_diss.e09d86b8.png";